import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { authState } from '../recoil/authState';
import { Suspense } from 'react';
import Layout from '../layouts';
import useLog from '../hooks/useLog';

const PrivateRoute = ({ children }) => {
    const auth = useRecoilValue(authState);
    const location = useLocation();
    useLog();
    
    // CEO 계정이고 타임라인 페이지인 경우 레이아웃 없이 렌더링
    const isMaster = Number(auth?.user?.club_admin_level) === 10;
    const isTimelinePage = location.pathname === '/analytics/timeline';
    
    if (!auth.isLoggedIn) {
        return <Navigate to={`/login`} />;
    }
    
    // CEO 계정의 타임라인 페이지는 레이아웃 없이 독립적으로 렌더링
    if (isMaster && isTimelinePage) {
        return (
            <Suspense>
                <Outlet />
            </Suspense>
        );
    }
    
    return (
        <Layout>
            <Suspense>
                <Outlet />
            </Suspense>
        </Layout>
    );
};

export default PrivateRoute;
